import React from 'react';
import { useQuery } from '@common/hooks';
import { PROFILE_STATUS_SETUP_DRAWER_APPLICATION_QUERY } from '@working-experience/graphql';
import { ErrorHandler } from '@common/components';
import { ProfileStatusSetupBaseDrawer } from '@working-experience/components';

export function ProfileStatusSetupApplicationDrawer({
  open,
  onClose,
  applicationId,
  dnr: doNotRehireQueryParam,
}: {
  open: boolean;
  onClose: () => void;
  applicationId?: string;
  dnr?: boolean;
}) {
  const {
    loading: queryApplicationLoading,
    error: queryApplicationError,
    data: queryApplicationData,
  } = useQuery(PROFILE_STATUS_SETUP_DRAWER_APPLICATION_QUERY, {
    variables: { id: applicationId || '' },
    skip: !applicationId,
  });

  if (queryApplicationError) {
    return (
      <ErrorHandler
        messageType="contextual"
        error={queryApplicationError}
        log="ProfileStatusSetupApplicationDrawer"
      />
    );
  }

  return (
    <ProfileStatusSetupBaseDrawer
      open={open}
      onClose={onClose}
      entity={queryApplicationData?.staffingRequestApplication}
      applicationId={applicationId}
      loading={queryApplicationLoading}
      doNotRehireQueryParam={doNotRehireQueryParam}
    />
  );
}
